import gql from 'graphql-tag';

export const ORGANIZATION_NOTIFICATION_PREFERENCES_CREATE_MUTATION = gql`
  mutation OrganizationNotificationPreferencesCreateMutation(
    $organizationNotificationPreferencesCreateInput: OrganizationNotificationPreferencesCreateInput!
  ) {
    createOrganizationNotificationPreferences(
      notificationPreferences: $organizationNotificationPreferencesCreateInput
    ) {
      id
      memberId
      injuryReport
      inaccurateTimeReport
      breakReport
      createdOn
      submittedOn
      updatedOn
      deletedOn
      cursor
    }
  }
`;

export const ORGANIZATION_NOTIFICATION_PREFERENCES_UPDATE_MUTATION = gql`
  mutation OrganizationNotificationPreferencesUpdateMutation(
    $organizationNotificationPreferencesUpdateInput: OrganizationNotificationPreferencesUpdateInput!
  ) {
    updateOrganizationNotificationPreferences(
      notificationPreferences: $organizationNotificationPreferencesUpdateInput
    ) {
      id
      memberId
      injuryReport
      inaccurateTimeReport
      breakReport
      createdOn
      submittedOn
      updatedOn
      deletedOn
      cursor
    }
  }
`;
